<template>
  <div class="modal-out">
    <div class="modal" style="width: 800px;">
      <div class="modal-header">
        <div class="title">添加</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body" style="height: 300px;">

        <div style="padding: 0px 10px;">

          <el-input size="mini" v-model="addForm.elderlyName" placeholder="选择残疾人" disabled style="width: 150px;">
            <el-button size="mini" slot="append" icon="el-icon-search" @click="getElderly"></el-button>
          </el-input>

          <div style="float:right" v-if="addForm.elderlyCode != ''">

            <el-button type="primary" size="mini" @click.native="toggleModalAdd">添加</el-button>
            <el-button type="success" size="mini" @click.native="handleEdit">编辑</el-button>
            <el-button type="info" size="mini" @click.native="handleInfo" style="margin-right: 10px;">用药详情</el-button>

            <el-date-picker size="mini"
              ref="picker"
              v-model="datetimerangeValue"
              type="daterange"
              :clearable='false'
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              style="width:230px;margin-right:10px">
            </el-date-picker>

            <el-button size="mini" type="primary" icon="el-icon-search" @click="getList">搜索</el-button>
          </div>

          <div style="clear: both;"></div>
        </div>

        <el-calendar v-model="calendarDate" :range='range' v-if="addForm.elderlyCode != ''">
          <template slot="dateCell" slot-scope="{date, data}">

            <p :class="isSelecteds(date) ? 'is-selected' : ''">
              {{ data.day.split('-').slice(1).join('-') }} {{ isSelecteds(date) ? '✔️' : ''}}
            </p>

            <el-popover v-if="getDayInfo(date)"
                        placement="top-start" width="150" trigger="hover">
              <el-button slot="reference" size="small" type="text">已排药</el-button>

              <div>
                <div>
                  <div>早晨用药</div>
                  <span v-for="item in getDayInfo(date).medicationSchedulingMorningDTO.medicationSchedulingMorningItemList" :key="item.dishesCode">
                    <span>药组：{{item.medicationGroupName}}<br></span>
                  </span>
                </div>
                <div>
                  <div>中午用药</div>
                  <span v-for="item in getDayInfo(date).medicationSchedulingNoonDTO.medicationSchedulingNoonItemList" :key="item.dishesCode">
                      <span>药组：{{item.medicationGroupName}}<br></span>
                  </span>
                </div>
                <div>
                  <div>晚上用药</div>
                  <span v-for="item in getDayInfo(date).medicationSchedulingNightDTO.medicationSchedulingNightItemList" :key="item.dishesCode">
                      <span>药组：{{item.medicationGroupName}}<br></span>
                  </span>
                </div>
              </div>

            </el-popover>

          </template>
        </el-calendar>

      </div>


    </div>

    <Elderly ref="myElderly" v-show="showModalGetElderly" v-on:closeElderly="showModalGetElderly=false" v-on:setElderly="setElderly"></Elderly>

    <Add2 ref="myAdd2" v-show="showModalAdd" v-on:closeAdd="closeAdd" v-on:getList="getList"></Add2>
    <Edit2 ref="myEdit2" v-show="showModalEdit" v-on:closeEdit="closeEdit" v-on:getList="getList"></Edit2>
    <Info2 ref="myInfo2" v-show="showModalInfo" v-on:closeInfo="closeInfo" v-bind:dataList="tableData"></Info2>


  </div>
</template>

<script>

import {timefilters, timeStr} from "@/common/times";
import {getStaffCode} from "@/utils/auth";
import {hex_md5} from "@/common/Base64MD5";

import Elderly from  "@/views/Elderly/Comm/ElderlyInsCheckIn2";

import Add2 from "./Add2";
import Edit2 from "./Edit2";
import Info2 from "./Info2";

export default {
  name: "Add",
  data() {
    return {
      loading: false,

      showModalGetElderly:false,

      showModalAdd:false,
      showModalEdit:false,
      showModalInfo:false,

      addForm:{
        elderlyCode:'',
        elderlyName:'',
      },

      dateList:[],
      datetimerangeValue:'',
      calendarDate:'',
      range:[],

      tableData:[],

      pickerOption: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        },
      },

      rules:{
        time:[
          { required: true, message: '请选择用药排班时间', trigger: 'blur' },
        ],
      },

      type:'',


    }
  },
  components:{
    Elderly,Add2,Edit2,Info2
  },

  watch: {
    calendarDate(val){
      this.getDate(val)
    }
  },
  methods: {
    init(type){
      this.addForm.elderlyCode = '';
      this.addForm.elderlyName = '';

      this.type = type;
    },
    closeSelf() {
      this.$emit("closeAdd");
    },


    getWeekDate(date){

      var startDate=new Date(date[0]);
      startDate.setDate(startDate.getDate() - startDate.getDay() + 1);

      var endDate=new Date(date[1])
      endDate.setDate(endDate.getDate() - endDate.getDay() + 7);

      this.range=[timefilters(startDate).slice(0,10),timefilters(endDate).slice(0,10)];

    },

    timefilter(row, column, cellValue){
      return timefilters(cellValue)
    },

    isSelecteds(date){
      var list=this.dateList
      var getDate=timefilters(date).slice(0,10)
      if(list.indexOf(getDate)>-1){
        return true
      }
      return false
    },

    getDayInfo(data){
      var list=this.tableData
      var row=''
      list.forEach(element => {
        if(timefilters(element.time).slice(0,10)==timefilters(data).slice(0,10)){
          row=element
        }
      });
      return row
    },

    getDate(date){
      var newDate=timefilters(new Date()).slice(0,10)
      var getDate=timefilters(date).slice(0,10)
      if(new Date(newDate)<=new Date(date)){
        var list=this.dateList
        if(list.indexOf(getDate)>-1){
          list.splice(list.indexOf(getDate), 1)
        }else{
          list.push(getDate)
        }
        this.dateList=list
      }
      else{
        this.$message.error('只能编辑今天及以后的排班')
      }
    },



    getElderly(){
      this.showModalGetElderly = !this.showModalGetElderly;
      this.$refs.myElderly.init(this.type);
    },
    setElderly(row){

      this.addForm.elderlyCode = row.elderlyCode;
      this.addForm.elderlyName = row.name;

      const start= new Date();
      const end=new Date(start.getTime() + 1000 * 60 * 60 * 24 * 15);
      this.datetimerangeValue=[start, end];
      this.getWeekDate(this.datetimerangeValue);

      this.getList();

    },
    getList(){
      this.loading = true;

      this.getWeekDate(this.datetimerangeValue);

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"MedicationScheduling/ElderlyList2",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          elderlyCode:this.addForm.elderlyCode,
          startTime:this.range[0],
          endTime:this.range[1],
        }
      }).then( (response)=> {
        this.loading = false;
        if(response.data.error == 0){
          this.tableData = response.data.data.list;
          this.dateList=[];
          this.$emit("getList");
        }
      }).catch(function (error) {
        console.log(error);
      });
    },





    toggleModalAdd:function(){

      if(!this.dateList.length){
        this.$message.error('请选择排班日期')
        return
      }

      var row;
      for(var i in this.dateList){
        if(this.getDayInfo(this.dateList[i])){
          this.$message.error('请去除已排班日期，已排班日期可通过修改编辑')
          row=this.getDayInfo(this.dateList[i])
          break;
        }
      }

      if(!row){
        this.showModalAdd = true;
        this.$refs.myAdd2.init(this.dateList,this.addForm.elderlyCode);
      }

    },
    closeAdd:function(){
      this.showModalAdd = !this.showModalAdd;
    },

    handleEdit() {

      if(!this.dateList.length){
        this.$message.error('请选择排班日期')
        return
      }
      if(this.dateList.length>1){
        this.$message.error('只能编辑单个排班')
        return
      }
      var row=this.getDayInfo(this.dateList[0])
      if(!row){
        this.$message.error('请先添加,再修改')
        return
      }
      this.$refs.myEdit2.init(row);
      this.showModalEdit = !this.showModalEdit;
    },
    closeEdit:function(){
      this.showModalEdit = !this.showModalEdit;
    },

    handleInfo(){
      this.showModalInfo=true
      this.$refs.myInfo2.init();
    },
    closeInfo:function(){
      this.showModalInfo = !this.showModalInfo;
    },



  }
}
</script>

<style lang="scss" scoped>

</style>
